'use client';
"use strict";

var _excluded = ["id", "isRequired", "isInvalid", "isDisabled", "isReadOnly"],
    _excluded2 = ["getRootProps", "htmlProps"],
    _excluded3 = ["isDisabled", "isInvalid", "isReadOnly", "isRequired"],
    _excluded4 = ["id", "disabled", "readOnly", "required", "isRequired", "isInvalid", "isReadOnly", "isDisabled", "onFocus", "onBlur"],
    _excluded5 = ["className", "children", "requiredIndicator", "optionalIndicator"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  FormControl: function FormControl() {
    return _FormControl;
  },
  FormErrorIcon: function FormErrorIcon() {
    return _FormErrorIcon;
  },
  FormErrorMessage: function FormErrorMessage() {
    return _FormErrorMessage;
  },
  FormHelperText: function FormHelperText() {
    return _FormHelperText;
  },
  FormLabel: function FormLabel() {
    return _FormLabel;
  },
  RequiredIndicator: function RequiredIndicator() {
    return _RequiredIndicator;
  },
  useFormControl: function useFormControl() {
    return _useFormControl;
  },
  useFormControlContext: function useFormControlContext() {
    return _useFormControlContext;
  },
  useFormControlProps: function useFormControlProps() {
    return _useFormControlProps;
  },
  useFormControlStyles: function useFormControlStyles() {
    return _useFormControlStyles;
  },
  useFormErrorStyles: function useFormErrorStyles() {
    return _useFormErrorStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/form-control.tsx

var import_react_context = require("@chakra-ui/react-context");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_system = require("@chakra-ui/system");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_react = require("react");

var import_jsx_runtime = require("react/jsx-runtime");

var _ref = (0, import_react_context.createContext)({
  name: "FormControlStylesContext",
  errorMessage: "useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormControl />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    FormControlStylesProvider = _ref2[0],
    _useFormControlStyles = _ref2[1];

var _ref3 = (0, import_react_context.createContext)({
  strict: false,
  name: "FormControlContext"
}),
    _ref4 = _slicedToArray(_ref3, 2),
    FormControlProvider = _ref4[0],
    _useFormControlContext = _ref4[1];

function useFormControlProvider(props) {
  var idProp = props.id,
      isRequired = props.isRequired,
      isInvalid = props.isInvalid,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      htmlProps = _objectWithoutProperties(props, _excluded);

  var uuid = (0, import_react.useId)();
  var id = idProp || "field-".concat(uuid);
  var labelId = "".concat(id, "-label");
  var feedbackId = "".concat(id, "-feedback");
  var helpTextId = "".concat(id, "-helptext");

  var _ref5 = (0, import_react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      hasFeedbackText = _ref6[0],
      setHasFeedbackText = _ref6[1];

  var _ref7 = (0, import_react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      hasHelpText = _ref8[0],
      setHasHelpText = _ref8[1];

  var _ref9 = (0, import_react.useState)(false),
      _ref10 = _slicedToArray(_ref9, 2),
      isFocused = _ref10[0],
      setFocus = _ref10[1];

  var getHelpTextProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({
      id: helpTextId
    }, props2), {}, {
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: (0, import_react_use_merge_refs.mergeRefs)(forwardedRef, function (node) {
        if (!node) return;
        setHasHelpText(true);
      })
    });
  }, [helpTextId]);
  var getLabelProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: forwardedRef,
      "data-focus": (0, import_shared_utils.dataAttr)(isFocused),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid),
      "data-readonly": (0, import_shared_utils.dataAttr)(isReadOnly),
      id: props2.id !== void 0 ? props2.id : labelId,
      htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
    });
  }, [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]);
  var getErrorMessageProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({
      id: feedbackId
    }, props2), {}, {
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: (0, import_react_use_merge_refs.mergeRefs)(forwardedRef, function (node) {
        if (!node) return;
        setHasFeedbackText(true);
      }),
      "aria-live": "polite"
    });
  }, [feedbackId]);
  var getRootProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread(_objectSpread({}, props2), htmlProps), {}, {
      ref: forwardedRef,
      role: "group",
      "data-focus": (0, import_shared_utils.dataAttr)(isFocused),
      "data-disabled": (0, import_shared_utils.dataAttr)(isDisabled),
      "data-invalid": (0, import_shared_utils.dataAttr)(isInvalid),
      "data-readonly": (0, import_shared_utils.dataAttr)(isReadOnly)
    });
  }, [htmlProps, isDisabled, isFocused, isInvalid, isReadOnly]);
  var getRequiredIndicatorProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: forwardedRef,
      role: "presentation",
      "aria-hidden": true,
      children: props2.children || "*"
    });
  }, []);
  return {
    isRequired: !!isRequired,
    isInvalid: !!isInvalid,
    isReadOnly: !!isReadOnly,
    isDisabled: !!isDisabled,
    isFocused: !!isFocused,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    hasFeedbackText: hasFeedbackText,
    setHasFeedbackText: setHasFeedbackText,
    hasHelpText: hasHelpText,
    setHasHelpText: setHasHelpText,
    id: id,
    labelId: labelId,
    feedbackId: feedbackId,
    helpTextId: helpTextId,
    htmlProps: htmlProps,
    getHelpTextProps: getHelpTextProps,
    getErrorMessageProps: getErrorMessageProps,
    getRootProps: getRootProps,
    getLabelProps: getLabelProps,
    getRequiredIndicatorProps: getRequiredIndicatorProps
  };
}

var _FormControl = (0, import_system.forwardRef)(function FormControl2(props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Form", props);
  var ownProps = (0, import_system.omitThemingProps)(props);

  var _useFormControlProvid = useFormControlProvider(ownProps),
      getRootProps = _useFormControlProvid.getRootProps,
      _ = _useFormControlProvid.htmlProps,
      context = _objectWithoutProperties(_useFormControlProvid, _excluded2);

  var className = (0, import_shared_utils.cx)("chakra-form-control", props.className);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(FormControlProvider, {
    value: context,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(FormControlStylesProvider, {
      value: styles,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({}, getRootProps({}, ref)), {}, {
        className: className,
        __css: styles["container"]
      }))
    })
  });
});

_FormControl.displayName = "FormControl";

var _FormHelperText = (0, import_system.forwardRef)(function FormHelperText2(props, ref) {
  var field = _useFormControlContext();

  var styles = _useFormControlStyles();

  var className = (0, import_shared_utils.cx)("chakra-form__helper-text", props.className);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({}, field == null ? void 0 : field.getHelpTextProps(props, ref)), {}, {
    __css: styles.helperText,
    className: className
  }));
});

_FormHelperText.displayName = "FormHelperText"; // src/use-form-control.ts

var import_shared_utils2 = require("@chakra-ui/shared-utils");

function _useFormControl(props) {
  var _useFormControlProps2 = _useFormControlProps(props),
      isDisabled = _useFormControlProps2.isDisabled,
      isInvalid = _useFormControlProps2.isInvalid,
      isReadOnly = _useFormControlProps2.isReadOnly,
      isRequired = _useFormControlProps2.isRequired,
      rest = _objectWithoutProperties(_useFormControlProps2, _excluded3);

  return _objectSpread(_objectSpread({}, rest), {}, {
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": (0, import_shared_utils2.ariaAttr)(isInvalid),
    "aria-required": (0, import_shared_utils2.ariaAttr)(isRequired),
    "aria-readonly": (0, import_shared_utils2.ariaAttr)(isReadOnly)
  });
}

function _useFormControlProps(props) {
  var _a, _b, _c;

  var field = _useFormControlContext();

  var id = props.id,
      disabled = props.disabled,
      readOnly = props.readOnly,
      required = props.required,
      isRequired = props.isRequired,
      isInvalid = props.isInvalid,
      isReadOnly = props.isReadOnly,
      isDisabled = props.isDisabled,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      rest = _objectWithoutProperties(props, _excluded4);

  var labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];

  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }

  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }

  return _objectSpread(_objectSpread({}, rest), {}, {
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id != null ? id : field == null ? void 0 : field.id,
    isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
    isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
    isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
    isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
    onFocus: (0, import_shared_utils2.callAllHandlers)(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: (0, import_shared_utils2.callAllHandlers)(field == null ? void 0 : field.onBlur, onBlur)
  });
} // src/form-error.tsx


var import_icon = require("@chakra-ui/icon");

var import_react_context2 = require("@chakra-ui/react-context");

var import_system2 = require("@chakra-ui/system");

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_jsx_runtime2 = require("react/jsx-runtime");

var _ref11 = (0, import_react_context2.createContext)({
  name: "FormErrorStylesContext",
  errorMessage: "useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormError />\" "
}),
    _ref12 = _slicedToArray(_ref11, 2),
    FormErrorStylesProvider = _ref12[0],
    _useFormErrorStyles = _ref12[1];

var _FormErrorMessage = (0, import_system2.forwardRef)(function (props, ref) {
  var styles = (0, import_system2.useMultiStyleConfig)("FormError", props);
  var ownProps = (0, import_system2.omitThemingProps)(props);

  var field = _useFormControlContext();

  if (!(field == null ? void 0 : field.isInvalid)) return null;
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(FormErrorStylesProvider, {
    value: styles,
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({}, field == null ? void 0 : field.getErrorMessageProps(ownProps, ref)), {}, {
      className: (0, import_shared_utils3.cx)("chakra-form__error-message", props.className),
      __css: _objectSpread({
        display: "flex",
        alignItems: "center"
      }, styles.text)
    }))
  });
});

_FormErrorMessage.displayName = "FormErrorMessage";

var _FormErrorIcon = (0, import_system2.forwardRef)(function (props, ref) {
  var styles = _useFormErrorStyles();

  var field = _useFormControlContext();

  if (!(field == null ? void 0 : field.isInvalid)) return null;

  var _className = (0, import_shared_utils3.cx)("chakra-form__error-icon", props.className);

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    ref: ref,
    "aria-hidden": true
  }, props), {}, {
    __css: styles.icon,
    className: _className,
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    })
  }));
});

_FormErrorIcon.displayName = "FormErrorIcon"; // src/form-label.tsx

var import_system3 = require("@chakra-ui/system");

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _FormLabel = (0, import_system3.forwardRef)(function FormLabel2(passedProps, ref) {
  var _a;

  var styles = (0, import_system3.useStyleConfig)("FormLabel", passedProps);
  var props = (0, import_system3.omitThemingProps)(passedProps);

  var className = props.className,
      children = props.children,
      _props$requiredIndica = props.requiredIndicator,
      requiredIndicator = _props$requiredIndica === void 0 ? /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_RequiredIndicator, {}) : _props$requiredIndica,
      _props$optionalIndica = props.optionalIndicator,
      optionalIndicator = _props$optionalIndica === void 0 ? null : _props$optionalIndica,
      rest = _objectWithoutProperties(props, _excluded5);

  var field = _useFormControlContext();

  var ownProps = (_a = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _a : _objectSpread({
    ref: ref
  }, rest);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsxs)(import_system3.chakra.label, _objectSpread(_objectSpread({}, ownProps), {}, {
    className: (0, import_shared_utils4.cx)("chakra-form__label", props.className),
    __css: _objectSpread({
      display: "block",
      textAlign: "start"
    }, styles),
    children: [children, (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator]
  }));
});

_FormLabel.displayName = "FormLabel";

var _RequiredIndicator = (0, import_system3.forwardRef)(function RequiredIndicator2(props, ref) {
  var field = _useFormControlContext();

  var styles = _useFormControlStyles();

  if (!(field == null ? void 0 : field.isRequired)) return null;
  var className = (0, import_shared_utils4.cx)("chakra-form__required-indicator", props.className);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.span, _objectSpread(_objectSpread({}, field == null ? void 0 : field.getRequiredIndicatorProps(props, ref)), {}, {
    __css: styles.requiredIndicator,
    className: className
  }));
});

_RequiredIndicator.displayName = "RequiredIndicator"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  FormControl: _FormControl,
  FormErrorIcon: _FormErrorIcon,
  FormErrorMessage: _FormErrorMessage,
  FormHelperText: _FormHelperText,
  FormLabel: _FormLabel,
  RequiredIndicator: _RequiredIndicator,
  useFormControl: _useFormControl,
  useFormControlContext: _useFormControlContext,
  useFormControlProps: _useFormControlProps,
  useFormControlStyles: _useFormControlStyles,
  useFormErrorStyles: _useFormErrorStyles
});